<template>
    <div v-observe-visibility="visibilityChanged">

        <!--        Creating Supplier Requests loading Dialog-->
        <v-dialog class="loading-dialog"
                  v-model="supplierRequestsWillBeCreated"
                  persistent
                  overlay
                  max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex xs12>
                        <v-card-title class="headline">Creating requests...</v-card-title>
                    </v-flex>
                    <v-flex justify-end>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <!--        Error Creating Supplier Requests Dialog-->
        <v-dialog class="loading-dialog"
                  v-model="supplierRequestsWillBeCreatedError"
                  persistent
                  overlay
                  max-width="600px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex xs12>
                        <v-card-title class="headline">{{creatingRequestsErrorMsg}}</v-card-title>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="supplierRequestsWillBeCreatedError = false">Ok</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>


        <!--EDIT - Dialog-->
        <v-dialog v-model="editDialog" max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit Position</span>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex sm12 pl-4 pa-2>
                                <v-text-field
                                        label="Intern-Number"
                                        v-model="editInquiryPositionData.internal_number"
                                        :rules="numberRules"
                                        counter
                                        maxlength="255"
                                ></v-text-field>
                            </v-flex>

                            <v-flex sm12 pl-4 pa-2>
                                <v-text-field
                                        label="Item-Number"
                                        v-model="editInquiryPositionData.item_number"
                                        :rules="numberRules"
                                        counter
                                        maxlength="255"
                                ></v-text-field>
                            </v-flex>

                            <v-flex sm12 pl-4 pa-2>
                                <v-autocomplete
                                        clearable
                                        :items="getManufacturers"
                                        label="Manufacturer"
                                        v-model="editInquiryPositionData.manufacturers_id"
                                        item-value="id"
                                        item-text="name"
                                        :disabled="editInquiryPositionData.inquiries_position_status_id > 1"
                                ></v-autocomplete>
                            </v-flex>

                            <v-flex sm12 pl-4 pa-2>
                                <v-text-field
                                        label="Quantity"
                                        v-model="editInquiryPositionData.quantity"
                                        type="number"
                                        min="1"

                                ></v-text-field>
                            </v-flex>

                            <v-flex sm12 pl-4 pa-2>
                                <v-autocomplete
                                        clearable
                                        :items="getUnits"
                                        label="Unit"
                                        v-model="editInquiryPositionData.units_id"
                                        item-value="id"
                                        item-text="name"
                                ></v-autocomplete>
                            </v-flex>

                            <v-flex sm12 pl-4 pa-2 pb-0>
                                <v-textarea
                                        auto-grow
                                        rows="1"
                                        label="Customer Description"
                                        v-model="editInquiryPositionData.customer_description"
                                        :rules="descriptionRules"
                                        counter
                                        maxlength="500"

                                ></v-textarea>
                            </v-flex>

                            <v-flex sm12 pl-4 pa-2 pb-0>
                                <v-textarea
                                        auto-grow
                                        rows="1"
                                        label="Supplier Description"
                                        v-model="editInquiryPositionData.supplier_description"
                                        :rules="descriptionRules"
                                        counter
                                        maxlength="500"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="editDialog = false">Cancel</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="saveInquiryPosition(editInquiryPositionData)">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Position</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this position?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="deleteInquiryPosition(editInquiryPositionData)">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Position Input view-->
        <v-layout>
            <v-flex xs12 mr-4 ml-4 mt-2>
                <v-card color="white lighten-4">
                    <v-layout row wrap v-show="hide">
                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Intern-Number"
                                    v-model="newInquiryPosition.internal_number"
                                    :rules="numberRules"
                                    counter
                                    maxlength="255"
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md2 pl-4 pa-2>
                            <!--                            <v-text-field
                                                                label="Item-Number"
                                                                v-model="newInquiryPosition.item_number"
                                                                :rules="numberRules"
                                                                counter
                                                                maxlength="255"
                                                        ></v-text-field>-->
                            <v-combobox
                                    clearable
                                    :items="getProducts"
                                    label="Item-Number"
                                    v-model="selectedProduct"
                                    item-text="reference"
                                    :filter="lesserReferenceFilter"
                                    :loading="loading"
                                    :search-input.sync="searchProduct"
                            ></v-combobox>
                        </v-flex>

                        <v-flex sm12 md2 pl-4 pa-2>
                            <v-autocomplete
                                    clearable
                                    :items="getManufacturers"
                                    label="Manufacturer"
                                    v-model="newInquiryPosition.manufacturers_id"
                                    item-value="id"
                                    item-text="name"
                                    :disabled="manufacturerPreselected"
                            ></v-autocomplete>
                        </v-flex>


                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Quantity"
                                    v-model="newInquiryPosition.quantity"
                                    type="number"
                                    min="1"

                            ></v-text-field>
                        </v-flex>


                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-autocomplete
                                    clearable
                                    :items="getUnits"
                                    label="Unit"
                                    v-model="newInquiryPosition.units_id"
                                    item-value="id"
                                    item-text="name"
                            ></v-autocomplete>
                        </v-flex>

                        <v-flex sm12 md2 pl-4 pa-2 pb-0>
                            <v-layout wrap>

                                <v-textarea
                                        auto-grow
                                        rows="1"
                                        label="Customer Description"
                                        v-model="newCustomerDescription"
                                        :rules="descriptionRules"
                                        counter
                                        maxlength="500"

                                ></v-textarea>
                                <lang-flag :squared="squareFlag" :iso='getDetectedLang'/>
                            </v-layout>
                        </v-flex>

                        <v-flex sm12 md2 pl-4 pa-2 pb-0>
                            <v-layout wrap>
                                <v-textarea
                                        auto-grow
                                        rows="1"
                                        label="Supplier Description"
                                        v-model="getTranslation"
                                        :rules="descriptionRules"
                                        counter
                                        maxlength="500"
                                ></v-textarea>
                                <lang-flag :squared="squareFlag" iso='en'/>
                            </v-layout>
                        </v-flex>

                        <v-flex sm12 md1 pl-4 pa-2 pb-0 mt-4>
                            <v-btn
                                    absolute
                                    right
                                    color="secondary"
                                    @click.native="saveInquiryPosition()"

                            >
                                <v-icon>add</v-icon>

                            </v-btn>
                        </v-flex>

                    </v-layout>
                    <v-layout row>
                        <v-spacer></v-spacer>
                        <v-btn
                                v-if="hide"
                                flat
                                icon
                                small
                                color="secondary"
                                @click.stop="hide = !hide"
                        >
                            <v-icon>expand_less</v-icon>
                        </v-btn>

                        <v-btn
                                v-else
                                flat
                                icon
                                small
                                color="secondary"
                                @click.stop="hide = !hide"
                        >
                            <v-icon>expand_more</v-icon>
                        </v-btn>


                        <v-spacer></v-spacer>

                    </v-layout>
                </v-card>
            </v-flex>

        </v-layout>

        <v-layout id="table-container" row mr-4 mt-4 ml-4>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        Inquriry Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 inquiry-table"
                            :loading="loading"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{ props.item.internal_number }}</td>
                                <td class="text-xs-left">{{ getPropertyByPath(props.item,'manufacturer.name','-') }}</td>
                                <td class="text-xs-left">{{ props.item.item_number }}</td>
                                <td class="text-xs-left">{{ props.item.quantity }}</td>
                                <td class="text-xs-left">{{ props.item.unit.code }}</td>
                                <td class="text-xs-left">{{ props.item.inquiries_positions_status.name }}</td>
                                <td class="text-xs-left">

                                    <v-autocomplete
                                            label="Suppliers"
                                            multiple
                                            chips
                                            persistent-hint
                                            :deletable-chips=chipsDeletable
                                            v-model="props.item.suppliers"
                                            item-value="id"
                                            item-text="name"
                                            :items="(props.item.suppliers < getSuppliers ? getSuppliers : props.item.suppliers)"
                                            @click="loadSuppliers(props.item.manufacturers_id)"></v-autocomplete>
                                </td>
                                <td class="text-xs-right">

                                    <v-icon
                                            v-show="props.item.products_id !== null"
                                            color="green"
                                            class="ma-1"
                                            @click=""
                                    >
                                        fa fa-files-o
                                    </v-icon>

                                    <v-icon
                                            v-show="props.item.haveToSave"
                                            color="secondary"
                                            class="ma-1"
                                            @click="saveInquiryPosition(props.item)"
                                    >
                                        save
                                    </v-icon>

                                    <v-icon color="primary"
                                            class="ma-1"
                                            @click="editInquiryPosition(props.item)"
                                    >
                                        edit
                                    </v-icon>

                                    <v-icon color="red"
                                            class="ma-1"
                                            @click="deleteInquiryPositionDialog(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>

        </v-layout>

        <v-layout pb-3 mt-5 mr-3 row justify-end>
            <v-btn mt-5 dark color="secondary" @click.native="createSupplierRequests(1)">
                Create Supplier Requests
                <v-icon class="white--text" right>arrow_forward</v-icon>
            </v-btn>
        </v-layout>


    </div>
</template>

<script>
    import {
        Settings,
        Inquiry,
        InquiryPosition,
        ManufacturersSettings,
        ProductSettings
    } from '../../../store/namespace-helper'

    import {comboAutoCompleteFiltersMixin} from '../../../mixins/comboAutoCompleteFiltersMixin'
    import {propertyHelperMixin} from '../../../mixins/propertyHelperMixin'

    import _ from 'lodash'

    export default {
      name: 'InquirySuppliers',
      mixins: [comboAutoCompleteFiltersMixin, propertyHelperMixin],
      data () {
        return {
          isVisible: false,
          hide: true,
          activeTab: 0,
          headers: [
                    {text: 'Position-ID', value: 'id'},
                    {text: 'Internal Number', value: 'internal_number'},
                    {text: 'Manufacturer', value: 'manufacturers_id'},
                    {text: 'Item Number', value: 'item_number'},
                    {text: 'Quantity', value: 'quantity'},
                    {text: 'Unit', value: 'unit_id', sortable: false},
                    {text: 'Status', value: 'inquiries_position_status_id'},
                    {text: 'Suppliers', value: 'inquires_position_has_suppliers', sortable: false},
                    {text: 'Actions', value: '', sortable: false}
          ],
          pagination: {},
          search: '',
          total: 0,
          onDismissed: false,
          rowsPageItems: [10, 25, 50, 100, 250],
          selectedSuppliers: null,
          chipsDeletable: true,
          newCustomerDescription: '',
          selectedProduct: '',
          newInquiryPosition: {
            id: 0,
            inquiries_id: 0,
            products_id: '',
            internal_number: '',
            manufacturers_id: 0,
            quantity: null,
            units_id: 28,
            item_number: '',
            inquiries_position_status_id: 1,
            customer_description: '',
            supplier_description: ''

          },
          editInquiryPositionData: {
            id: 0,
            inquiries_id: 0,
            internal_number: '',
            manufacturers_id: 0,
            quantity: null,
            item_number: '',
            inquiries_position_status_id: 1,
            customer_description: '',
            supplier_description: ''

          },
          manufacturerPreselected: false,
          editDialog: false,
          deleteDialog: false,
          deleteChecked: false,
          deleteFormValidation: false,
          supplierRequestsWillBeCreated: false,
          supplierRequestsWillBeCreatedError: false,
          rules: {
            required: value => !!value || 'Required.',
            descriptionCounter: value => value.length <= 500 || 'Max 500 characters',
            numberCounter: value => value.length <= 255 || 'Max 255 characters'
          },
          creatingRequestsErrorMsg: '',
          squareFlag: false,
          unwatch: null,
          searchProduct: null

        }
      },
      beforeDestroy () {
        this.unwatch()
      },
      mounted () {
        this.unwatch = this.$watch('getItems', function (after) {
          let vm = this
          after.filter(function (p, idx) {
            return Object.keys(p).some(function (prop) {
              if (prop === 'suppliers') {
                let lenBefore = vm.$store.getters[InquiryPosition.getters.inquiriesPositionsCopy].data[idx][prop].length
                let lenAfter = p[prop].length
                if (lenBefore !== lenAfter) {
                  vm.$store.getters[InquiryPosition.getters.inquiriesPositions].data[idx].haveToSave = true
                  return p
                }
              } else if (prop === 'manufacturers_id') {
                if (vm.$store.getters[InquiryPosition.getters.inquiriesPositionsCopy].data[idx][prop] !== p[prop]) {
                  vm.$store.getters[InquiryPosition.getters.inquiriesPositions].data[idx].haveToSave = true
                  return p
                }
              } else if (
                          prop === 'internal_number' ||
                          prop === 'item_number' ||
                          prop === 'quantity' ||
                          prop === 'customer_description' ||
                          prop === 'supplier_description'
                      ) {
                if (vm.$store.getters[InquiryPosition.getters.inquiriesPositionsCopy].data[idx][prop] !== p[prop]) {
                  vm.$store.getters[InquiryPosition.getters.inquiriesPositions].data[idx].haveToSave = true
                  return p
                }
              }
            })
          })
              // update object copy
          vm.$store.dispatch(InquiryPosition.actions.updateInquiriesPositionsCopy)
        }, { deep: true })
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadItems()
              this.loadManufacturers()
              this.loadUnits()
             /* this.loadProducts() */
            } else {

            }
          }
        },
        loadItems: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            id: this.getSelectedInquiry.id,
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          this.$store.dispatch(InquiryPosition.actions.loadInquiriesPositions, query)
        },
        loadManufacturers () {
          this.$store.dispatch(ManufacturersSettings.actions.loadAllManufacturers)
        },
        loadUnits () {
          this.$store.dispatch(Settings.actions.loadAllUnits)
        },
        loadSuppliers (manufacturersId) {
          console.log('loading all suppliers for manufacturers_id: ' + manufacturersId)
          this.$store.dispatch(Settings.actions.loadSuppliersByManufacturers, manufacturersId)
        },
        saveInquiryPosition (item) {
          if (typeof item !== 'undefined') {
            this.newInquiryPosition = item
          }

          console.log('saveInquiryPosition: ' + JSON.stringify(this.getSelectedInquiry))

          this.newInquiryPosition.inquiries_id = this.getSelectedInquiry.id

          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const requestData = {
            id: this.getSelectedInquiry.id,
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : '',
            inquiryPosition: _.cloneDeep(this.newInquiryPosition)
          }
          this.$store.dispatch(InquiryPosition.actions.saveInquiriesPositions, requestData)

          this.newInquiryPosition = {
            id: 0,
            inquiries_id: 0,
            internal_number: '',
            manufacturers_id: 0,
            quantity: null,
            units_id: 28,
            item_number: '',
            inquiries_position_status_id: 1,
            customer_description: '',
            supplier_description: '',
            products_id: ''
          }

          this.newInquiryPosition.products_id = null
          this.selectedProduct = ''
          this.manufacturerPreselected = false

          this.newCustomerDescription = ''
          this.getTranslation = ''

          this.editDialog = false
        },
        deleteInquiryPosition (item) {
          if (!this.$refs.form.validate()) {
            return
          }

          this.deleteDialog = false
          this.deleteChecked = false

          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const requestData = {
            id: this.getSelectedInquiry.id,
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : '',
            inquiryPosition: item
          }

          this.$store.dispatch(InquiryPosition.actions.deleteInquiriesPositions, requestData)
        },
        createSupplierRequests () {
          this.supplierRequestsWillBeCreated = true
          this.$echo.private('request-created-chan.' + this.getSelectedInquiry.id).listen('SupplierRequestsCreated', (payload) => {
            console.log('message sent event: ' + JSON.stringify(payload))
                    // this.loadItems()
            if (payload.data.error === false) {
              this.supplierRequestsWillBeCreated = false
            } else {
              this.supplierRequestsWillBeCreated = false
              this.supplierRequestsWillBeCreatedError = true
              this.creatingRequestsErrorMsg = payload.data.msg
            }

            this.$echo.leave('request-created-chan.' + this.getSelectedInquiry.id)
          })
          this.$store.dispatch(InquiryPosition.actions.createSupplierRequests, this.getSelectedInquiry)
          window.onbeforeunload = function () {
            return 'Are you sure you want to leave?'
          }
        },
        deleteInquiryPositionDialog (item) {
          this.editInquiryPositionData = _.cloneDeep(item)
          this.deleteDialog = true
        },
        cancelDeleteDialog () {
          this.deleteDialog = false
          this.$refs.form.reset()
        },
        editInquiryPosition (item) {
          this.editInquiryPositionData = _.cloneDeep(item)
          this.editDialog = true
        },
        translate (q, target) {
          this.$store.dispatch(Settings.actions.translate, {
            q: q,
            target: target
          })
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        throttledTranslate: _.debounce(function (q, target) {
          this.translate(q, target)
        }, 450),
        loadProducts () {
          const searchProduct = {
            search: this.searchProduct
        /*    fulltext: true */
          }
          this.$store.dispatch(ProductSettings.actions.loadAllProducts, searchProduct)
        },
        throttledLoadProducts: _.debounce(function () {
          this.loadProducts()
        }, 450)

      },
      computed: {
        getItems () {
          this.total = this.$store.getters[InquiryPosition.getters.inquiriesPositions].total
          return this.$store.getters[InquiryPosition.getters.inquiriesPositions].data
        },
        getTranslation: {
          get () {
            this.newInquiryPosition.customer_description = this.newCustomerDescription
            if (this.$store.getters[Settings.getters.getTranslation][0].translatedText !== null) {
              this.newInquiryPosition.supplier_description = this.$store.getters[Settings.getters.getTranslation][0].translatedText
              return this.$store.getters[Settings.getters.getTranslation][0].translatedText
            } else {
              return ''
            }
          },
          set (val) {
            this.$store.getters[Settings.getters.getTranslation][0].translatedText = val
          }
        },
        getDetectedLang: {
          get () {
            if (this.$store.getters[Settings.getters.getTranslation][0].detectedSourceLanguage !== null) {
              return this.$store.getters[Settings.getters.getTranslation][0].detectedSourceLanguage
            } else {
              return ''
            }
          },
          set () {
            this.$store.getters[Settings.getters.getTranslation][0].detectedSourceLanguage = ''
          }
        },
        getSuppliers () {
          return this.$store.getters[Settings.getters.getManufacturerSuppliers]
        },
        getSelectedInquiry () {
          return this.$store.getters[Inquiry.getters.getSelectedInquiry]
        },
        getManufacturers () {
          return this.$store.getters[ManufacturersSettings.getters.getAllManufacturers]
        },
        getUnits () {
          return this.$store.getters[Settings.getters.getAllUnits]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        descriptionRules () {
          return [this.rules.descriptionCounter]
        },
        numberRules () {
          return [this.rules.numberCounter]
        },
        getProducts () {
          return this.$store.getters[ProductSettings.getters.getAllProducts]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        selectedProduct: {
          handler (val) {
            if (val) {
              console.log('selectedProduct')
              console.log(JSON.stringify(val))
              if (typeof val !== 'string') {
                this.newInquiryPosition.manufacturers_id = val.manufacturer.id
                this.newInquiryPosition.item_number = val.reference
                this.newInquiryPosition.products_id = val.id
                this.manufacturerPreselected = true
              } else {
                this.newInquiryPosition.manufacturers_id = null
                this.newInquiryPosition.item_number = val
                this.newInquiryPosition.products_id = null
                this.manufacturerPreselected = false
              }
            } else {
              this.newInquiryPosition.manufacturers_id = null
              this.newInquiryPosition.item_number = val
              this.newInquiryPosition.products_id = null
              this.manufacturerPreselected = false
            }
          },
          deep: true
        },
/*        getItems: {
          handler (after) {
            var vm = this
            after.filter(function (p, idx) {
              return Object.keys(p).some(function (prop) {
                if (prop === 'suppliers') {
                  var lenBefore = vm.$store.getters[InquiryPosition.getters.inquiriesPositionsCopy].data[idx][prop].length
                  var lenAfter = p[prop].length
                  if (lenBefore !== lenAfter) {
                    vm.$store.getters[InquiryPosition.getters.inquiriesPositions].data[idx].haveToSave = true
                    return p
                  }
                } else if (prop === 'manufacturers_id') {
                  if (vm.$store.getters[InquiryPosition.getters.inquiriesPositionsCopy].data[idx][prop] !== p[prop]) {
                    vm.$store.getters[InquiryPosition.getters.inquiriesPositions].data[idx].haveToSave = true
                    return p
                  }
                } else if (
                                prop === 'internal_number' ||
                                prop === 'item_number' ||
                                prop === 'quantity' ||
                                prop === 'customer_description' ||
                                prop === 'supplier_description'
                            ) {
                  if (vm.$store.getters[InquiryPosition.getters.inquiriesPositionsCopy].data[idx][prop] !== p[prop]) {
                    vm.$store.getters[InquiryPosition.getters.inquiriesPositions].data[idx].haveToSave = true
                    return p
                  }
                }
              })
            })
                    // update object copy
            vm.$store.dispatch(InquiryPosition.actions.updateInquiriesPositionsCopy)
          },
          deep: true
        }, */
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        },
        searchProduct: {
          handler (val) {
            if (val) {
              this.throttledLoadProducts()
            } else {
              this.$store.dispatch(ProductSettings.actions.resetState)
            }
          },
          deep: true
        },
        newCustomerDescription: {
          handler (val) {
            if (val.length > 3) {
              this.throttledTranslate(val, 'en')
            } else {
              this.getTranslation = ''
              this.getDetectedLang = ''
            }
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }


</style>



// WEBPACK FOOTER //
// src/components/Distribution/Supplier/InquirySuppliers.vue